import React from 'react';
import util from "../../util/tools";
import commonTools from "../../../common/util/util";
import P from "prop-types";

export default class Home extends React.Component {
    static propTypes = {
        location: P.any,
        history: P.any,
        actions: P.any
    };
    
    constructor(props) {
        super(props);
        this.state = {
            curTitle: "接口测试页",
        };
    }

    componentDidMount() {
        document.title = this.state.curTitle;
        if(!!commonTools.searchPar().url){
          let obj = {};
          Object.assign(obj,commonTools.searchPar());
          util.ajax(obj);
        }
    }

    render() {
        return (
            <div>接口测试</div>
        );
    }
}